import { useEffect, useState } from "react";
import { mapBranchRoute, parseBranchLinkDataFromUrl } from "../utils/branch";
import type { BranchLinkData } from "../utils/branch.types";

interface UseBranchResult {
  route: string | null;
  error: string | null;
  isLoading: boolean;
}

export const useBranch = (leaseId: number | null, propertyId: number | null): UseBranchResult => {
  const [route, setRoute] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    try {
      const linkData: BranchLinkData = parseBranchLinkDataFromUrl(window.location.href);

      if (!linkData.notificationType || !leaseId || !propertyId) {
        setRoute("/");
      } else {
        setRoute(mapBranchRoute(linkData, leaseId, propertyId));
      }
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setIsLoading(false);
    }
  }, [leaseId, propertyId]);

  return { route, error, isLoading };
};
